
    import { defineComponent } from 'vue'
    import Card from 'primevue/card'
    import Listbox from 'primevue/listbox'

    export default defineComponent({
        name: 'workspace-federation-definition-metafields-list',
        components: { Card, Listbox },
        props: { propDataset: { type: Object }, selectedMetafields: { type: Array }, resetSelectedMetafield: { type: Boolean } },
        data() {
            return {
                dataset: null as any,
                selectedMetafield: null as any,
                selected: [] as any[]
            }
        },
        watch: {
            propDataset() {
                this.loadDataset()
            },
            selectedMetafields() {
                this.loadSelectedMetafields()
            },
            resetSelectedMetafield() {
                this.selectedMetafield = null
            }
        },
        created() {
            this.loadDataset()
            this.loadSelectedMetafields()
        },
        methods: {
            loadDataset() {
                this.dataset = this.propDataset as any[]
            },
            loadSelectedMetafields() {
                this.selected = this.selectedMetafields as any[]
            },
            metafieldsSelected(metafield: any) {
                if (!this.selectedMetafield) {
                    this.removeMetafieldFromSelected()
                } else if (this.selected.length < 2 && this.dataset.id !== this.selected[0]?.dataset.id && this.dataset.id !== this.selected[1]?.dataset.id) {
                    this.selected.push({ dataset: this.dataset, metafield: metafield })
                } else if (this.dataset.id === this.selected[0]?.dataset.id || this.dataset.id === this.selected[1]?.dataset.id) {
                    this.removeMetafieldFromSelected()
                    this.selected.push({ dataset: this.dataset, metafield: metafield })
                } else if (this.selected.length === 2) {
                    this.removeMetafieldFromSelected()
                    this.selectedMetafield = null
                }
            },
            removeMetafieldFromSelected() {
                const index = this.selected.findIndex((el: any) => el.dataset.id === this.dataset.id)
                if (index !== -1) this.selected.splice(index, 1)
            }
        }
    })
